module.exports = __webpack_public_path__ + "media/images/faces/male/24-6d0fa5c747aab857e4f254fa98eb4ec3.jpg";